<template lang="pug">
.entity-pivot
  app-entity-controller-multiple(
    v-bind="{ value, entity, wheres, entityProps }",
    :searchEntity="nodeEntity",
    :customLoad="searchLoad",
    :hardCodedValues="createHardCodedValues"
    vertical,
    :showLabel="false",
    :toggleDialog.sync="dialog",
    v-on="{ added }",
    :disableCreateButton="disableCreateButton"
  )
    template(v-slot:entityDisplay="{ entity, value }")
      v-container.py-0(fluid)
        v-row
          template(v-for="(element, i) in value")
            v-col.px-1(:cols="6", v-if="isNotDeleted(element)")
              app-entity-display.contact-display(
                :value="treatObject(element)",
                @edit="onEditDisplay(element, i)",
                @close="deleted(element, i)",
                :key="key+ '' + i",
                close,
                :showKey="false",
                :showHeader="false",
                valueClass="h10",
                v-bind="{ entity }",
              )
</template>

<style lang="scss" scoped>
.entity-pivot {
  ::v-deep .contact-display {
    .g-btn {
      color: var(--v-text-base) !important;
    }
    .entity-display_actions {
      padding-bottom: 0;
      .v-btn--icon.v-size--small {
        .mdi-close,
        .mdi-pencil {
          font-size: 18px;
        }
        height: 12px;
        width: 12px;
      }
    }
    .entity-display_form {
      .h10 {
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 100%;
        overflow:hidden;
      }
      &:first-child {
        padding-bottom: 0;
        .h10 {
          font-size: 13px;
          font-weight: 800;
        }
      }
    }
  }
}
</style>

<script>
import EntityMixin from '@/mixins'
import axios from 'axios'
export default {
  mixins: [EntityMixin],
  props: {
    //- Real entity to pivot with parent entity (i.e. Contact for ShipmentContacts)
    entity: null,
    //- Route on the main entity object where the list will be applied (i.e. "shipmentContacts")
    path: null,
    //- List of already existing items on the pivot
    value: {
        type: Array,
        default: () => ([]),
    },
    //- Name of the field to be displayed on the cards
    displayFields: {
        type: Array,
        default: () => ([]),
    },
    //- Property to create new pivot
    disableCreateButton: {
        type: Boolean,
        default: false
    },
    //- Relation related to the pivot
    relation: {
      type: Object,
      default: () => ({}),
    },
    //- Display from top to bottom instead horizontally
    vertical: {
      type: Boolean,
      default: false,
    },
    // - Contains a list of predefined values that will be injected into each item in the array emmited.
    hardCodedValues: {
        type: Object,
        default: () => ({}),
    },
    hardCodedElementValues: {
        type: Object,
        default: () => ({}),
    },
    createHardCodedValues: {
        type: Object,
        default: () => ({}),
    },
    // - used for naming the "fake" entity to the pivot (i.e. ShipmentContact)
    entityAlias: null,
    //- Current parent entity selected for the pivot
    mainEntity: {
      type: Object,
      default: () => ({})
    },
    //- The nodes entity to be linked to the main Entity in the pivot (i.e. Party for Party-Contacts)
    nodeEntity: {
      type: Object,
      default: () => ({})
    },
     //- The parent Entity currently selected within the Pivot
    selectedParent: null,
    //- Generic additional props
    parentInstance: null,
    parent: null,
    searchLoad: {
      type: Array,
      default: () => ([]),
    },
    elementPath: null,
    //- Extra props sent to entity
    entityProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    dialog: false,
    key: 0,
    wheres: [],
  }),
  methods: {
    added(searchedElement) {
      const copyValue = _.cloneDeep(this.value);
      const entityName = _.get(this.entity, 'name').toLowerCase();

      // Check if searchedElement is a pivot relation entity
      // If yes, use a path of its own to handle the added
      const searchedElementEntity = _.get(searchedElement, '_Entity');
      const nodeEntityEntity = _.get(this.nodeEntity, 'name');
      let element = this.elementPath && (searchedElementEntity === nodeEntityEntity) ? _.get(searchedElement, this.elementPath, {}) : searchedElement;

      let found = _.find(copyValue, vElement => vElement[`${entityName}Id`] === element.id);

      // Found means, an edition was sent
      if (found) {
        found[entityName] = element;

        // If it was previously deleted, restore.
        if (found.entityState == 2)
          found.entityState = 0;
      }
      else if(!found) {
        element = {
          ...element,
          ...this.hardCodedElementValues,
        };

        const treatedValue = {
          ...this.hardCodedValues,
          _Entity: this.entityAlias,
          [entityName]: element,
          [`${entityName}Id`]: element.id,
          entityState: 4,
        }
        copyValue.push({ ...treatedValue });
      }
      this.$emit('input', copyValue);
    },
    onEditDisplay(element, i) {
      const copyElement = _.cloneDeep(_.get(element, this.elementPath, {}));
      this.$store.commit('SET_MODAL_INSTANCE', { ...copyElement });
      this.dialog = true;
    },
    deleted(instance, i) {
      const copyValue = _.cloneDeep(this.value);
      if (instance.entityState == 4)
        copyValue.splice(i, 1);
      else
        copyValue[i].entityState = 2;
      this.$emit('input', copyValue);
    },
    treatObject(element) {
      return _.pick(element.contact, this.displayFields);
    },
    isNotDeleted(element) {
      return !(_.get(element, 'entityState') === 2);
    },
    async updateSelectorList(value) {
      if(value && value.id) {
          this.wheres = [];

          if(this.mainEntity) {
            this.wheres.push(`x=>x.${this.$lcfirst(this.mainEntity.name)}Id=${value.id}`);
          }
      }
    },
    clearSelectedList() {
      let copyValue = _.cloneDeep(this.value);

      copyValue = _.reduce(copyValue, (acc, pc) => {
        const pcState = _.get(pc, 'entityState');
        const copyPc = _.cloneDeep(pc);
        if (pcState !== 4) {
          copyPc.entityState = 2;
          acc.push(copyPc);
        }
        return acc;
      }, []);

      this.$emit('input', copyValue);
    }
  },
  watch: {
    selectedParent: {
      immediate: false,
      handler(val) {
        this.updateSelectorList(val);
        this.clearSelectedList();
      }
    }
  },
  computed: {},
  mounted() {
    this.updateSelectorList(this.selectedParent);
  },
}
</script>
